import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import TextEditor from "@/components/ui/emailTemplatePlaceholder";
import { Label } from "@/components/ui/label";
import { useEffect, useState } from "react";
import toastService from "@/services/toastService";

import { createEmailTemplate, UpdateEmailTemplate } from "@/features/user-profile/services/emailTemplateServices";
import PlaceholderInput from "../ui/dynamicPlaceholders";

interface EmailTemplateDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  type: "add" | "edit";
  Refresh: () => void;
  emailTemplateValues?:any[];


  initialValues?: {
    name: string;
    subject: string;
    body_html: string;
    id?: number;
  };
}

const EmailTemplateDialog: React.FC<EmailTemplateDialogProps> = ({
  open,
  onOpenChange,
  initialValues,
 
  Refresh,

  type,
   emailTemplateValues,
}) => {
  const [templateName, setTemplateName] = useState(initialValues?.name ?? "");
  const [subject, setSubject] = useState(initialValues?.subject ?? "");
  const [messageBody, setMessageBody] = useState(
    initialValues?.body_html ?? ""
  );
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (open) {
      setTemplateName(initialValues?.name ?? "");
      setSubject(initialValues?.subject ?? "");
      setMessageBody(initialValues?.body_html ?? "");
    }
  }, [initialValues, open]);

  console.log(emailTemplateValues,"line 54")

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      const payload = {
        templateData: {
          name: templateName,
          subject,
          body_html: messageBody,
        },
        forCrm: true,
      };

      if (type === "add") {
        await createEmailTemplate(payload);
        toastService.success("Template created successfully");
        Refresh?.();
      } else {
        if (!initialValues?.id) {
          console.error("Template ID is missing for update");
          return;
        }

        await UpdateEmailTemplate(initialValues.id, {
          name: templateName,
          subject,
          body_html: messageBody,
        });
        toastService.success("Template updated successfully");
        Refresh?.();
      }

      onOpenChange(false);
    } catch (e) {
      toastService.error("Something went wrong");
      console.error(e);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[65%] p-0 flex flex-col  rounded-xl h-[85%] overflow-y-auto bg-white">
        <DialogHeader className="bg-[#f4f4f4] text-[#202b49] px-6 py-4 ">
          <DialogTitle className="text-xl">
            {type === "add" ? "Add New Template" : "Edit Template"}
          </DialogTitle>
        </DialogHeader>
        <div className="flex-1 overflow-y-auto px-6  space-y-3">
          <div>
            <Label className="block text-sm font-medium mb-2 text-gray-600">
              Template Name<span className="ml-1">*</span>
            </Label>
            <Input
              autoFocus={false}
              name="name"
              value={templateName}
              onChange={(e) => setTemplateName(e.target.value)}
              placeholder="Enter Template Name"
              className="h-[40px]"
            />
          </div>

          <div>
            {/* <Label className="block text-sm font-medium mb-2 text-gray-600">
              Email Subject
            </Label>
            <Input
              autoFocus={false}
              name="name"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              placeholder="Enter Email Subject"
              className="h-[40px]"
            /> */}
            <Label className="block text-sm font-medium mb-2 text-gray-600">
  Email Subject <span className="ml-1">*</span>
</Label>

<PlaceholderInput
  value={subject}
  onChange={(val) => setSubject(val)}
  emailTemplateValues={emailTemplateValues}
/>
             
          </div>

        
        
            <TextEditor content={messageBody}   type={type} setContent={setMessageBody} emailTemplateValues={emailTemplateValues} />
        
        </div>

        {/* Footer Actions */}
        <div className="border-t px-6 py-4 flex justify-end space-x-2 bg-white">
          <Button
            variant="secondary"
            className="px-6 py-1 h-[40px]"
            onClick={() => {
              setTemplateName("");
              setSubject("");
              setMessageBody("");
              onOpenChange(false);
            }}
          >
            Cancel
          </Button>
          <Button
            className="px-6 py-1 h-[40px] bg-[#181818]"
            onClick={handleSubmit}
            disabled={
              isSubmitting ||
              !templateName.trim() ||
              !subject.trim() ||
              !messageBody.trim()
            }
          >
            {isSubmitting
              ? "Saving..."
              : type === "add"
                ? "Continue"
                : "Save Changes"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EmailTemplateDialog;
